import api from './api';

/**
 * Get all journals with optional filters
 * @param {Object} params - Query parameters
 * @returns {Promise<Object>} Journals list with pagination
 */
export const getJournals = async (params = {}) => {
  const response = await api.get('/admin/journals', { params });
  return response.data;
};

/**
 * Get journal statistics
 * @returns {Promise<Object>} Journal stats
 */
export const getJournalStats = async () => {
  const response = await api.get('/admin/journals/stats');
  return response.data;
};

/**
 * Get a single journal by ID
 * @param {number} id - Journal ID
 * @returns {Promise<Object>} Journal object
 */
export const getJournalById = async (id) => {
  const response = await api.get(`/admin/journals/${id}`);
  return response.data;
};

/**
 * Approve a journal
 * @param {number} id - Journal ID
 * @returns {Promise<Object>} Updated journal
 */
export const approveJournal = async (id) => {
  const response = await api.put(`/admin/journals/${id}/approve`);
  return response.data;
};

/**
 * Reject a journal
 * @param {number} id - Journal ID
 * @param {string} reason - Optional rejection reason
 * @returns {Promise<Object>} Updated journal
 */
export const rejectJournal = async (id, reason = '') => {
  const response = await api.put(`/admin/journals/${id}/reject`, { reason });
  return response.data;
};

/**
 * Delete a journal
 * @param {number} id - Journal ID
 * @returns {Promise<Object>} Deletion result
 */
export const deleteJournal = async (id) => {
  const response = await api.delete(`/admin/journals/${id}`);
  return response.data;
};

const journalsService = {
  getJournals,
  getJournalStats,
  getJournalById,
  approveJournal,
  rejectJournal,
  deleteJournal
};

export default journalsService;

